type CashbackCapMinSpendInfoProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'className'
>;

export const CashbackCapMinSpendInfo = ({
  ...rest
}: CashbackCapMinSpendInfoProps) => {
  return (
    <div
      className='relative mb-8 block w-full text-center text-cr-body-sm-400 text-neutral-400  md:text-cr-body-lg-400'
      {...rest}
    >
      <span>
        *Cashback cap and/or minimum spend applies. See store page for details.
      </span>
    </div>
  );
};
